import React from 'react';

const Button = ({ buttonConfig }) => {
  return (
    <div className="flex justify-center lg:justify-start">
      <button
        key={buttonConfig.id}
        onClick={buttonConfig.onClick}
        disabled={buttonConfig.disabled}
        className={`
          w-32 p-2 rounded-3xl text-secondary
          border-2 border-secondary
          hover:bg-secondary hover:text-primary
          disabled:opacity-40 disabled:cursor-not-allowed
          transition-all duration-200
          ${buttonConfig.additionalClasses || ''}
        `}
      >
        {buttonConfig.link ? (
          <a
            href={buttonConfig.link}
            target={buttonConfig.newTab ? '_blank' : '_self'}
            rel="noreferrer"
            download={
              buttonConfig.download
                ? 'Taguhi_Karakashyan_CV.pdf'
                : null
            }
          >
            {buttonConfig.text}
          </a>
        ) : (
          buttonConfig.text
        )}
      </button>
    </div>
  );
};

export default Button;